export default  class Roles{

    // NOTE: FOR ADMIN TO ALLOW ALL ROLES ADD THIS VALUE TO DATABASE USERS TABLE ROLES -> {"admin":"admin"}
    // 
	constructor(user, pages, router){
        this.user = (user) ? user:null;
        this.pages = pages;
        this.router = router;
        this.checkbox = [];

        this.allowed_player_pages = [
            'dashboard', 'bet_history', 'bet_add', 'winners',
        ];
    }
    
    listRoles(){
        return [
            {text: 'View', value: '0'},
            {text: 'Add', value: '1'},
            {text: 'Edit', value: '2'},
            {text: 'Delete', value: '3'},
        ]
    }

    listOtherRoles(){
        let roles = [
            { text: "Administer email templates", value: "administer_email_templates" },
            { text: "Administer SMS", value: "administer_sms" },
        ]
        return roles;
    }

    listPages(){
        let pages = [];
        for(let i = 0; i < this.pages.length; i++){
            if(this.pages[i].isPage){
                pages.push({
                    'value': this.pages[i].name,
                    'text': this.pages[i].meta.title,
                });
            }
        }
        return pages;
    }

    byPassPage(pagename){
        let bol = false;
        let arr = [
            '/login',
            '/two-factor-auth',
        ];

        if(arr.indexOf(pagename) > -1){
            bol = true;
        }
        return bol;
    }

    restrictPlayerPages(pagename){
        let bol = true;
        if( this.user.state.currentUser.isplayer ){
            if( this.allowed_player_pages.indexOf(pagename) > -1 ){
                bol = true;
            }else{
                bol = false;
            }
        }
        return bol;
    }


    restricAccess(pagename, section){
        let result = null;

        // RESTRICT PAGES FROM LOGGED PLAYERS
        if(!this.restrictPlayerPages(pagename)){
            this.router.push({path: '/error-404'});
            return false;
            // result = false;
        }

        // IGNORE ROLES IF PAGE IS ON THE LIST TO BYPASS
        if(this.byPassPage(pagename)){
            return true;
        }

        // BYPASS MENU IF isPage VALUE IS FALSE
        if(this.isPageCheck(pagename) == false){
            return true;
        }

        let roles = null;
        if(this.user.state.isLoggedIn && this.user.state.isAuthFactorPass){
            roles = this.user.state.currentUser.roles;
        }

        if(roles != null){

            if(roles.admin == 'admin'){
                return true;
            }

            let pageControll = {};
            Object.keys(roles).forEach(key => {
                let temp = key.split('__');
                if(temp[0] == pagename){
                    let status = roles[key];
                    pageControll[temp[1]] = status;
                }
            });

            Object.keys(pageControll).forEach(key => {
                if(key.toUpperCase() == section.toUpperCase()){
                    result = pageControll[key];
                }
            });

        }

        if((section == 'view') && (!result)){
            this.router.push({path: '/error-404'});
        }else{
            return result;
        }
    }

    restricMenu(pagename){
        let roles = this.user.state.currentUser.roles;

        // RESTRICT PAGES FROM LOGGED PLAYERS
        if(!this.restrictPlayerPages(pagename)){
            return false;
        }

        // BYPASS MENU IF isPage VALUE IS FALSE
        if(this.isPageCheck(pagename) == false){
            return true;
        }

        if(roles != null){

            if(roles.admin == 'admin'){
                return true;
            }

            let bol = false;
            Object.keys(roles).forEach(key => {
                let temp = key.split('__');
                let status = roles[key];
                if(pagename == temp[0] && temp[1].toUpperCase() == 'VIEW' && status == true){
                    bol = status;
                }
            });
            return bol;
        }
    }
    
    restrictDropdownMenu(pages){
        let roles = this.user.state.currentUser.roles;
        if(roles != null){
            
            if(roles.admin == 'admin'){
                return true;
            }

            let bol = false;
            pages.forEach(pagename => {
                Object.keys(roles).forEach(key => {
                    let temp = key.split('__');
                    let status = roles[key];
                    if(pagename == temp[0] && temp[1].toUpperCase() == 'VIEW' && status == true){
                        bol = status;
                    }
                });
            });
            return bol;
        }
    }

    isPageCheck(pagename){
        let isPage = false;

        Object.keys(this.pages).forEach(key => {
            if(this.pages[key].name == pagename){
                if(this.pages[key].isPage){
                    isPage = true;
                }
            }
        });

        return isPage;
    }
}